import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../../../core/constants/api-routes';
import { FileTypeConstants } from '../../../../core/constants/file-type-constants';
import { formatDateToYYYYMMDDFromDate } from '../../../../core/functions/date-helpers';
import { AccountingReviewReportRequest } from '../models/accounting-review-report-request';
import { NewOrderReportSummaryResponse } from '../models/new-order-report-summary-response';
import { NewPaymentReportSummaryResponse } from '../models/new-payment-report-summary-response';
import { UpdatedExportedOrderReportSummaryResponse } from '../models/updated-exported-order-report-summary-response';

@Injectable({
    providedIn: 'root',
})
export class ReportService {
    private readonly http = inject(HttpClient);
    private readonly reportApiRoute = ApiRouteConstants.Report;

    exportNewOrdersReport(): Observable<HttpResponse<Blob>> {
        const headers = new HttpHeaders({ Accept: FileTypeConstants.XLSX });

        return this.http.post(
            this.reportApiRoute.getNewOrdersReportUrl(),
            null,
            {
                headers,
                responseType: 'blob',
                observe: 'response',
            },
        );
    }

    getNewOrdersReportInclusion(): Observable<NewOrderReportSummaryResponse> {
        return this.http.get<NewOrderReportSummaryResponse>(
            this.reportApiRoute.getNewOrdersReportInclusionUrl(),
        );
    }

    exportNewPaymentsReport(): Observable<HttpResponse<Blob>> {
        const headers = new HttpHeaders({ Accept: FileTypeConstants.XLSX });

        return this.http.post(
            this.reportApiRoute.getNewPaymentsReportUrl(),
            null,
            {
                headers,
                responseType: 'blob',
                observe: 'response',
            },
        );
    }

    getNewPaymentsReportInclusion(): Observable<NewPaymentReportSummaryResponse> {
        return this.http.get<NewPaymentReportSummaryResponse>(
            this.reportApiRoute.getNewPaymentsReportInclusionUrl(),
        );
    }

    exportUpdatedExportedOrdersReport(): Observable<HttpResponse<Blob>> {
        const headers = new HttpHeaders({ Accept: FileTypeConstants.XLSX });

        return this.http.post(
            this.reportApiRoute.getUpdatedExportedOrdersReportUrl(),
            null,
            {
                headers,
                responseType: 'blob',
                observe: 'response',
            },
        );
    }

    getUpdatedExportedOrdersReportInclusion(): Observable<UpdatedExportedOrderReportSummaryResponse> {
        return this.http.get<UpdatedExportedOrderReportSummaryResponse>(
            this.reportApiRoute.getUpdatedExportedOrdersReportInclusionUrl(),
        );
    }

    exportAccountingReviewReport(
        request: AccountingReviewReportRequest,
    ): Observable<HttpResponse<Blob>> {
        const headers = new HttpHeaders({ Accept: FileTypeConstants.XLSX });

        return this.http.get(
            this.reportApiRoute.getAccountingReviewReportUrl(),
            {
                headers,
                responseType: 'blob',
                observe: 'response',
                params: {
                    startDate: formatDateToYYYYMMDDFromDate(request.startDate),
                    endDate: formatDateToYYYYMMDDFromDate(request.endDate),
                    reportType: request.reportType,
                },
            },
        );
    }
}
